'use strict';

module.exports = function forget(key) {
  if (Array.isArray(this.items)) {
    this.items.splice(key, 1);
  } else {
    delete this.items[key];
  }

  return this;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/collect.js/dist/methods/forget.js
// module id = 581
// module chunks = 0